export enum FinancialComponentTypeEnum {
    Base = 1,
    Addition = 2,
    Deduction = 3
  }